class VisualMegaMenu extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-visual-mega-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-visual-mega-panel]'));

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('pointerenter', this.onActivate);
      tab.addEventListener('focus', this.onActivate);
    });

    const initialTab = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
    this.activate(initialTab.dataset.visualMegaTab);
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => {
      tab.removeEventListener('pointerenter', this.onActivate);
      tab.removeEventListener('focus', this.onActivate);
    });
  }

  onActivate = (event) => {
    const key = event.currentTarget?.dataset?.visualMegaTab;
    if (key) this.activate(key);
  };

  activate(key) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.visualMegaTab === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.visualMegaPanel === key;
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('hidden', !active);
    });
  }
}

if (!customElements.get('visual-mega-menu')) {
  customElements.define('visual-mega-menu', VisualMegaMenu);
}
